module.exports = __webpack_public_path__ + "img/w8b.1bf120c3.jpg";